import FileSaver from 'file-saver'

export function downloadJsonFile(filename, json, bom = true) {
    const bomCode = bom ? '\ufeff' : '';
    const blob = new Blob([`${bomCode}${JSON.stringify(json)}`], { type: 'application/json;charset=utf-8' });
    FileSaver.saveAs(blob, filename);
}